module.exports = __webpack_public_path__ + "static/media/bnb.8e821114.png";